import { isEffectiveProofRow } from './purchaseOrderProofScope';

const emptyProofSummary = {
  total: 0,
  uploaded: 0,
  approved: 0,
  rejected: 0,
  pendingClient: 0,
  pendingUser: 0,
  allProofsUploaded: false,
  displayStatus: 'Not Required',
  clientLinks: [],
};

const isNoProofish = (po = {}) => {
  const status = String(po.proofStatus || po.proofSummary?.displayStatus || '').trim().toLowerCase();
  return (
    status === '' ||
    status === 'no proof' ||
    status === 'not required' ||
    status === 'no proof required'
  ) && !po.proofRequired;
};

export const applyProofsChangeToPurchaseOrder = (po, poId, nextProofs, patch = {}, recomputeSummary) => {
  if (po?.id !== poId) return po;

  const { source, ...trustedPatch } = patch || {};
  const safeProofs = (Array.isArray(nextProofs) ? nextProofs : [])
    .filter((proof) => isEffectiveProofRow(proof, po));

  if (source === 'refresh' && isNoProofish(po) && safeProofs.length === 0) {
    return {
      ...po,
      ...trustedPatch,
      proofs: [],
      proofSummary: { ...emptyProofSummary },
      proofStatus: po.proofStatus,
    };
  }

  const updated = { ...po, proofs: safeProofs, ...trustedPatch };
  updated.proofSummary = typeof recomputeSummary === 'function'
    ? recomputeSummary(updated, safeProofs)
    : updated.proofSummary;

  if (source !== 'mutation' || !Object.prototype.hasOwnProperty.call(trustedPatch, 'proofStatus')) {
    updated.proofStatus = po.proofStatus;
  }

  return updated;
};
